import React from 'react'

export default class RiskFactorsComponent extends React.Component {
  render () {
    console.log(this.props.data)
    return (
      <div className='dashboard-medical-container'>
        <div className='header-medical-data'>
          <label>Factores de riesgo</label>
        </div>
        <div className='patient-special-information'>
          <div className='conditions-container'>
            <label className='data' id='RiskFactors'></label>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardRiskFactors.js